// ✅ GLOBAL FUNCTION (same as yours)

window.__cachedCartCount = null;

window.checkCartLimit = function (limit = 4) {
  if (window.__cachedCartCount !== null) {
    return Promise.resolve({
      allowed: window.__cachedCartCount < limit,
      count: window.__cachedCartCount
    });
  }

  return fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      window.__cachedCartCount = cart.item_count;
      return {
        allowed: cart.item_count < limit,
        count: cart.item_count
      };
    })
    .catch((e) => {
      console.error('Cart fetch error:', e);
      return { allowed: false, count: 0 };
    });
};

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

           onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('data-added') === 'true') {
          window.location.href = '/cart';
          return;
        }

        this.continueSubmit(evt);
      }

      continueSubmit(evt) {
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);

        const mainId = formData.get('id');
        const comboItems = this.form.querySelectorAll('.combo-item');

let items = [
  { id: mainId, quantity: 1 }
];

// Add ALL combo products
comboItems.forEach((el) => {
  const id = el.value;
  if (id) {
    items.push({ id: id, quantity: 1 });
  }
});

        // ✅ Check cart limit properly
               
        window.checkCartLimit(4).then((result) => {

          if ((result.count + items.length) > 4) {
            this.showLimitPopup('You can only add maximum 4 items to cart');
            this.stopLoading();
            return;
          }

          // ✅ Add both items (MAIN + COMBO)
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items })
          })
                    .then((res) => res.json())
          .then((addedCart) => {
            this.showCartPopup();
            this.stopLoading();
            this.markAddedToCart();

            fetch('/cart.js')
              .then(res => res.json())
              .then(cart => {
                // ✅ Cache update karo taaki agli baar fetch na lage
                window.__cachedCartCount = cart.item_count;

                this.updateCartBubble(cart);
                if (this.cart) {
                  try {
                    this.cart.renderContents(cart);
                  } catch (e) {
                    console.error('Cart render error:', e);
                  }
                }
              })
              .catch((e) => console.error('Cart fetch error:', e));
          })
          .catch((e) => {
            console.error(e);
            this.stopLoading();
          });
        });
      }

            showCartPopup() {
        window.positionAndShowPopup(this.submitButton);
      }

            updateCartBubble(cart) {
        window.updateGlobalCartBubble(cart);
      }

      markAddedToCart() {         
        if (this.submitButtonText) {
          this.submitButtonText.textContent = 'View Cart';
        }
        this.submitButton.classList.add('added-to-cart');
        this.submitButton.setAttribute('data-added', 'true');
      }

      stopLoading() {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.add('hidden');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      showLimitPopup(message) {
        let popup = document.querySelector('.cart-limit-popup');

        if (!popup) {
          popup = document.createElement('div');
          popup.className = 'cart-limit-popup';
          document.body.appendChild(popup);
        }

        popup.textContent = message;
        popup.classList.add('active');

        setTimeout(() => {
          popup.classList.remove('active');
        }, 3000);
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent =
            window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}






// ✅ GLOBAL — dusre sections (jaise preowned-picks) bhi isko use kar sakte hain
window.showAddToCartPopup = function () {
  let popup = document.getElementById('cstmCartPopup');

  if (!popup) {
    popup = document.createElement('div');
    popup.id = 'cstmCartPopup';
    popup.className = 'cstm-cart-popup';
    popup.innerHTML = `
      <span class="cstm-cart-popup__text">Item added to your cart</span>
      <a href="/cart" class="cstm-cart-popup__view">VIEW CART</a>
    `;
    document.body.appendChild(popup);
  }

  return popup;
};

window.positionAndShowPopup = function (buttonEl) {
  const popup = window.showAddToCartPopup();

  popup.classList.add('show');

  clearTimeout(window._cstmPopupTimer);
  window._cstmPopupTimer = setTimeout(() => {
    popup.classList.remove('show');
  }, 3000);
};

window.updateGlobalCartBubble = function (cart) {
  const cartIcon = document.getElementById('cart-icon-bubble');
  if (!cartIcon) return;

  let bubble = cartIcon.querySelector('.cart-count-bubble');

  if (cart.item_count > 0) {
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = `
        <span aria-hidden="true"></span>
        <span class="visually-hidden">items in cart</span>
      `;
      cartIcon.appendChild(bubble);
    }
    const countSpan = bubble.querySelector('span[aria-hidden]');
    if (countSpan) countSpan.textContent = cart.item_count < 100 ? cart.item_count : '';
  } else if (bubble) {
    bubble.remove();
  }
};



// ✅ Page load pe cart count cache karo (header bubble se, agar mil jaye)
document.addEventListener('DOMContentLoaded', () => {
  const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]');
  if (bubble && bubble.textContent.trim() !== '') {
    window.__cachedCartCount = parseInt(bubble.textContent.trim(), 10) || 0;
  } else {
    window.__cachedCartCount = 0;
  }
});
